/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const analyticsModule = require('@utils/analytics/analyticsModule');
const commonModule = require('@utils/common/commonModule');
const NavLinksService = require('./navLinksService');
const dropdownLinksDirective = require('./header/dropdownLinks/dropdownLinksDirective');
const mobileMenuDirective = require('./mobile_menu/mobileMenuDirective');
const MobileMenuService = require('./mobile_menu/mobileMenuService');
const FooterService = require('./footer/footerService');
const footerDirective = require('./footer/footerDirective');

const navigationModule = angular
    .module('enervee_utils.navigation', [
        analyticsModule.name,
        commonModule.name,
    ])
    .factory('NavLinksService', NavLinksService)
    .factory('MobileMenuService', MobileMenuService)
    .factory('FooterService', FooterService)
    .directive('dropdownLinks', dropdownLinksDirective)
    .directive('mobileMenu', mobileMenuDirective)
    .directive('enerveeFooter', footerDirective);

module.exports = navigationModule;